import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import VueScrollReveal from 'vue-scroll-reveal';


Vue.config.productionTip = false


// set app
let app= '';


// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDh6_9fxuVTTtMvWyMecx3_jIlIhuGXvdw",
  authDomain: "reservations-a2014.firebaseapp.com",
  databaseURL: "https://reservations-a2014.firebaseio.com",
  projectId: "reservations-a2014",
  storageBucket: "",
  messagingSenderId: "983923254862",
  appId: "1:983923254862:web:113d9efa31b9e58c"
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig);


// Reference reservations collection globally
// Global reference is this.$reservationRequests
var database = firebase.database();
Vue.prototype.$reservationRequests = database.ref('Reservations');


// Update router after firebase authorized change
firebase.auth().onAuthStateChanged(() => {
  if(!app) {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});
[1, 2, 3].map(x => x * x);

// Using ScrollReveal's default configuration
Vue.use(VueScrollReveal);
// OR specifying custom default options for all uses of the directive
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal',
  duration: 800,
  scale: 1,
  distance: '100px',
  origin: 'bottom'
});